import Marquee from "react-fast-marquee";

const ITEMS = [
  "AI-Powered Threat Detection",
  "Zero-Day Phishing Protection",
  "Real-Time Link Shielding",
  "Scam Pattern Intelligence",
  "Malicious URL Analysis",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-white/10 bg-[#030711] py-5 select-none"
  >
    <Marquee speed={28} gradient={false} autoFill pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-mono-ls text-xs sm:text-sm tracking-[0.25em] uppercase text-zinc-400 px-8">
            {item}
          </span>
          <span className="h-1.5 w-1.5 bg-[#00C5FE]" />
        </span>
      ))}
    </Marquee>
  </div>
);
